import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { media } from 'style-utils';

import {
  NitroTextField,
  NitroPanel,
  NitroHeading,
  NitroButtonGroup,
  NitroButton,
  NitroSnackbar,
  NitroLoading,
} from 'nitro-components';
import { SelectField, MenuItem } from 'material-ui';

import UserApi from '@src/api/UserApi';
import { notify, closeNotify } from '@src/components/libs/notification';
import DisableCover from '@src/components/libs/disabled';

export const UserDetailSection = styled.div`
  display: flex;
  ${media.desktop`
  flex-direction: row
  `} ${media.mobile`
  flex-direction: column
  `}
  flex-direction: column;
  justify-content: space-between;
`;

export const UserSection = styled.div`
  ${media.desktop`
  width: 40%
  `} ${media.mobile`
  width: 100%
  `}
  display: flex;
  flex-direction: column;
`;

export const InputLabel = styled.label`
  font-size: 12px;
  color: ${props => {
    if (typeof props.valid === 'undefined' || props.valid) {
      return props.theme.color.base1;
    }
    return 'red';
  }};
  margin-bottom: 8px;
`;

export const InputContainer = styled.div`
  position: relative;
  width: 100%;
  margin-top: 30px;
`;

const ActionSection = styled.div`
  margin-top: 10px;
`;

class ProfileDetails extends Component {
  static propTypes = {
    userId: PropTypes.string.isRequired,
    userName: PropTypes.string.isRequired,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    countryCode: PropTypes.string.isRequired,
    employerCompanyCode: PropTypes.string.isRequired,
    employerCompanyName: PropTypes.string.isRequired,
    mobile: PropTypes.string.isRequired,
    businessEntityName: PropTypes.string.isRequired,
    businessEntityId: PropTypes.number.isRequired,
    zoneName: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      userName: '',
      firstName: '',
      lastName: '',
      employerCompanyName: '',
      mobile: '',
      businessEntityName: '',
      countryCode: '',
      timezones: [],
      timeZone: {},
    };

    this.getTimzeZones = this.getTimzeZones.bind(this);
    this.onFieldChange = this.onFieldChange.bind(this);
    this.submitUserDetailsChange = this.submitUserDetailsChange.bind(this);
    this.updateUser = this.updateUser.bind(this);
    this.businessEntities = [];
  }

  componentWillMount() {
    const {
      userId,
      userName,
      firstName,
      lastName,
      countryCode,
      employerCompanyCode,
      employerCompanyName,
      mobile,
      businessEntityName,
      businessEntityId,
      zoneName,
      zoneId,
    } = this.props;

    let newState = {};

    newState = Object.assign({}, newState, {
      userId,
      userName,
      firstName,
      lastName,
      countryCode,
      employerCompanyCode,
      employerCompanyName,
      mobile,
      businessEntityName,
      businessEntityId,
      zoneName,
      zoneId,
    });
    this.setState(newState);
  }

  componentDidMount() {
    this.getTimzeZones(this.props.countryCode);
  }

  onFieldChange = (name, value) => {
    this.setState({
      [name]: value,
    });
  };

  getTimzeZones = countryCode => {
    // this.setLoading(true);
    if (countryCode)
      UserApi.getTimeZones(countryCode)
        .then(data => {
          // this.setLoading(false);
          this.setTimeZone(data);
        })
        .catch(err => err);
  };

  setTimeZone = timezones => {
    this.setState({
      timezones,
    });
  };

  setLoading = status => {
    this.setState({
      isLoading: status,
    });
  };

  extractTimeZone = zoneName => {
    const { timezones } = this.state;
    const timezone = timezones.find(z => z.zoneName === zoneName);
    return timezone;
  };

  submitUserDetailsChange = () => {
    const { userId, firstName, lastName, mobile, zoneId } = this.state;

    const userPost = {
      userId,
      firstName,
      lastName,
      mobile,
      zoneId,
    };

    this.updateUser(userPost);
  };

  updateUser = userModel => {
    const { notify } = this.props;
    this.setLoading(true);
    UserApi.updateuser(userModel)
      .then(data => {
        this.setLoading(false);
        if (data.success) {
          notify({
            title: 'User saved successfully',
          });
        } else {
          notify({
            type: 'error',
            title: 'User Update failed',
          });
        }
      })
      .catch(error => {
        this.setLoading(false);
        this.setState({
          openSnackBar: true,
          snackbarMsg: error,
        });
        throw error;
      });
  };

  clearSnackbarError = () => {
    this.setState({
      openSnackBar: false,
      snackbarMsg: undefined,
    });
  };

  render() {
    const { openSnackBar, snackbarMsg, isLoading } = this.state;

    const {
      firstName,
      lastName,
      userName,
      mobile,
      businessEntityName,
      employerCompanyName,
      employerCompanyCode,
      timezones,
      countryCode,
      zoneName,
    } = this.state;

    return (
      <NitroPanel>
        <NitroSnackbar
          open={openSnackBar}
          message={snackbarMsg}
          autoHideDuration={4000}
          onRequestClose={this.clearSnackbarError}
        />

        {isLoading && (
          <div>
            <DisableCover />
            <NitroLoading center screen />
          </div>
        )}
        <NitroHeading label="User Details" size="1" variant="secondary" />

        <UserDetailSection>
          <UserSection>
            <NitroTextField
              floatingLabelText="Username"
              value={userName}
              variant="base1"
              fullWidth
              onChange={event =>
                this.onFieldChange('userName', event.target.value)
              }
              disabled
            />

            <NitroTextField
              floatingLabelText="First name"
              value={firstName}
              onChange={event => {
                this.onFieldChange('firstName', event.target.value);
              }}
              fullWidth
              variant="base1"
              props
            />
            <NitroTextField
              floatingLabelText="Last name"
              value={lastName}
              onChange={event =>
                this.onFieldChange('lastName', event.target.value)
              }
              variant="base1"
              fullWidth
            />

            <NitroTextField
              floatingLabelText="Mobile number"
              value={mobile || ''}
              variant="base1"
              fullWidth
              onChange={event =>
                this.onFieldChange('mobile', event.target.value)
              }
            />
          </UserSection>

          <UserSection>
            <div>
              <NitroTextField
                floatingLabelText="Business Entity"
                value={
                  businessEntityName
                    ? `${businessEntityName} - ${this.state.countryCode.toUpperCase()}`
                    : ''
                }
                disabled
                variant="base1"
                fullWidth
              />

              <NitroTextField
                floatingLabelText="Employer"
                value={`${employerCompanyName} (${employerCompanyCode})` || ''}
                variant="base1"
                fullWidth
                disabled
              />
            </div>

            <SelectField
              floatingLabelText="Time Zones"
              fullWidth
              disabled={!countryCode}
              value={zoneName}
              floatingLabelStyle={{
                color: '#0000004d',
              }}
              selectedMenuItemStyle={{
                color: '#bbbbbb',
              }}
              underlineStyle={{
                borderBottomColor: '#0000004d',
              }}
              onChange={(event, key, payload) => {
                this.onFieldChange('zoneName', payload);
                const zone = this.extractTimeZone(payload);
                this.onFieldChange('timeZone', zone);
                this.onFieldChange('zoneId', zone.zoneId);
              }}>
              {timezones.length > 0 &&
                timezones.map((ea, idx) => {
                  const gmtOffset = ea.gmtOffset / 3600;
                  let text = '';
                  if (gmtOffset > 0) {
                    text = `(GMT + ${gmtOffset}) ${ea.zoneName}`;
                  } else {
                    text = `(GMT - ${gmtOffset}) ${ea.zoneName}`;
                  }
                  return (
                    <MenuItem
                      key={`timeZone_${ea.zoneId}`}
                      value={ea.zoneName}
                      primaryText={text}
                    />
                  );
                })}
            </SelectField>
          </UserSection>
        </UserDetailSection>

        <ActionSection>
          <NitroButtonGroup layout="horizontal">
            <NitroButton
              size="small"
              action={this.submitUserDetailsChange}
              label="Update"
              variant="primary"
              disabled={this.state.fetchingData}
              loading={this.state.fetchingData}
            />
          </NitroButtonGroup>
        </ActionSection>
      </NitroPanel>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  notify: bindActionCreators(notify, dispatch),
  closeNotify: bindActionCreators(closeNotify, dispatch),
});

export default connect(
  null,
  mapDispatchToProps
)(ProfileDetails);



// WEBPACK FOOTER //
// ./src/features/profile/ProfileDetails.js